import { ACTION } from './types';
import { ROUTE } from '../../../routes';
import { ButtonTypeTokens, DocumentPickerState, SizeTypeTokens, WIDGET, } from '@voltmoney/schema';
import { api } from '../../../configs/api';
import SharedPropsService from '../../../SharedPropsService';
import _ from 'lodash';
import { getAppHeader } from '../../../configs/config';
import { nextStepCredStepper } from '../../../configs/utils';
let documentUploadUrlMap = {
    frontDocURL: null,
    backDocURL: null,
};
const validation = {
    isDropDownSelected: false,
    isFrontDocUploaded: false,
    isBackDocUploaded: false,
};
export const GoBackAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const triggerAction = async (action, _datastore, { setDatastore, network, navigate }) => {
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, 'continue', {
        loading: true,
    });
    const response = await network.get(`${api.documentValidate}${applicationId}`, { headers: await getAppHeader() });
    await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, 'continue', {
        loading: false,
    });
    const currentStepId = _.get(response, 'data.updatedApplicationObj.currentStepId');
    const stepStatusMap = _.get(response, 'data.updatedApplicationObj.stepStatusMap');
    user.linkedApplications[0].currentStepId = currentStepId;
    user.linkedApplications[0].stepStatusMap = stepStatusMap;
    if (currentStepId) {
        await SharedPropsService.setUser(user);
        const routeObj = await nextStepCredStepper();
        await navigate(routeObj.routeId, routeObj.params);
    }
};
export const documentPickerAction = async (action, _datastore, { network, setDatastore }) => {
    if (action.payload.value) {
        const fileExtension = action.payload.value.name.split('.').pop();
        await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, action.payload.widgetID, {
            state: DocumentPickerState.LOADING,
        });
        const response = await network.put(action.payload.widgetID === 'frontSide'
            ? documentUploadUrlMap.frontDocURL
            : documentUploadUrlMap.backDocURL, action.payload.value, {
            headers: { 'Content-Type': getContentType(fileExtension) },
        });
        if (response.status === 200) {
            if (action.payload.widgetID === 'frontSide') {
                validation.isFrontDocUploaded = true;
            }
            if (action.payload.widgetID === 'backSide') {
                validation.isBackDocUploaded = true;
            }
            if (documentUploadUrlMap.backDocURL === null) {
                validation.isBackDocUploaded = true;
            }
            await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, action.payload.widgetID, {
                state: DocumentPickerState.SUCCESS,
            });
        }
        else {
            await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, action.payload.widgetID, {
                state: DocumentPickerState.DEFAULT,
            });
        }
    }
    if (validation.isDropDownSelected &&
        validation.isFrontDocUploaded &&
        validation.isBackDocUploaded) {
        await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const onSelectDocumentType = async (action, _datastore, { network, removeWidgets, appendWidgets, setDatastore }) => {
    validation.isDropDownSelected = true;
    validation.isFrontDocUploaded = false;
    validation.isBackDocUploaded = false;
    await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD, 'continue', {
        type: ButtonTypeTokens.LargeOutline,
    }); // reset continue button
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const documentUrlResponse = await network.post(`${api.kycDocument}${applicationId}`, { documentType: action.payload.value }, { headers: await getAppHeader() });
    documentUploadUrlMap = documentUrlResponse.data.stepResponseObject;
    await removeWidgets(ROUTE.KYC_DOCUMENT_UPLOAD, [
        { id: 'frontSide', type: WIDGET.DOCUMENT_PICKER },
        { id: 'frontSideSpace', type: WIDGET.SPACE },
        { id: 'backSide', type: WIDGET.DOCUMENT_PICKER },
    ]);
    const datastore = {
        frontSide: {
            titleLabel: 'Front side',
            ctaLabel: 'Upload',
            state: DocumentPickerState.DEFAULT,
            action: {
                type: ACTION.SELECT_DOCUMENT,
                routeId: ROUTE.KYC_DOCUMENT_UPLOAD,
                payload: {
                    value: { content: null, name: null },
                    widgetID: 'frontSide',
                },
            },
        },
    };
    if (documentUploadUrlMap.backDocURL !== null) {
        datastore['frontSideSpace'] = { size: SizeTypeTokens.XXXL };
        datastore['backSide'] = {
            titleLabel: 'Back side',
            ctaLabel: 'Upload',
            state: DocumentPickerState.DEFAULT,
            action: {
                type: ACTION.SELECT_DOCUMENT,
                routeId: ROUTE.KYC_DOCUMENT_UPLOAD,
                payload: {
                    value: { content: null, name: null },
                    widgetID: 'backSide',
                },
            },
        };
    }
    await appendWidgets(ROUTE.KYC_DOCUMENT_UPLOAD, datastore, [
        { id: 'frontSide', type: WIDGET.DOCUMENT_PICKER },
        { id: 'frontSideSpace', type: WIDGET.SPACE },
        { id: 'backSide', type: WIDGET.DOCUMENT_PICKER },
    ], 'dropDownSpace');
};
const getContentType = fileExtension => {
    switch (fileExtension) {
        case 'pdf':
            return 'application/pdf';
        case 'png':
            return 'image/png';
        case 'jpg':
            return 'image/jpeg';
        case 'jpeg':
            return 'image/jpeg';
        default:
            return 'application/pdf';
    }
};
